import { Globe, Lock } from 'lucide-react'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import * as Styled from '@/routes/database/tabs/overview/sections/connections/styles'

export const DatabaseConnectionsSectionFallback = () => (
  <Styled.ConnectionsGrid>
    <Card className="flex-1">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Lock className="size-4" /> <H3>Internal connection</H3>
        </div>
      </CardHeader>
      <CardContent className="text-sm">
        <div className="grid grid-cols-[max-content_1fr] gap-2 gap-x-4 items-center [&>*]:min-w-0">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
        </div>
      </CardContent>
    </Card>
    <Card className="flex-1">
      <CardHeader className="gap-0">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <Globe className="size-4" /> <H3>External connection</H3>
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-41" />
            <Skeleton className="h-8 w-35" />
          </div>
        </div>
      </CardHeader>
      <CardContent className="text-sm">
        <div className="grid grid-cols-[max-content_1fr] gap-2 gap-x-4 items-center [&>*]:min-w-0">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full" />
        </div>
      </CardContent>
    </Card>
  </Styled.ConnectionsGrid>
)
